import React, {useEffect} from 'react';
import useGet from "./hooks/useGet";
import usePreference from "./hooks/usePreference";
import {concepts} from "fearless-common";
import downloadLinks from "../libs/downloadLinks";
import {Apple, CheckSquareFill, Square, Windows} from "react-bootstrap-icons";
import {routes} from "../utils";
import Loading from "./Loading";
import trackEvent, {CATEGORIES, ACTIONS} from "./tracking/trackEvent";
import {backendEndpoints} from "../libs/backendEndpoints";
import useAuth from "./hooks/useAuth";

const filled = <CheckSquareFill className="text-secondary me-2" size={25} />;
const unfilled = <Square className="text-secondary me-2" size={25} />;

const hideValue = 'hidden';

/**
 * Shows a block with actions to get started using our platform to a user
 * who is new to Fearless League. So a new user does not log in and questions
 * him-/herself: and now what do I do?
 */
export default function GettingStarted() {
    const { user } = useAuth();
    const { data, isLoading: loadingTokens } = useGet<Array<any>>({
        endpoint: backendEndpoints.tokens
    });
    const { preferenceValue, setPreferenceValue } = usePreference('getting-started-visibility');

    const hasGroups = user && Array.isArray(user?.groups) && user.groups.length > 0;
    const isLoggedInOnDesktop = Boolean(Array.isArray(data) && data?.length > 0);

    const loadingAny = loadingTokens;
    const showList = !hasGroups || !isLoggedInOnDesktop;

    useEffect(() => {
        if (preferenceValue !== hideValue && !loadingAny && !showList) {
            // setPreferenceValue(hideValue);
        }
    }, [showList, loadingAny, setPreferenceValue, preferenceValue]);

    if (loadingAny) return null;

    return showList && preferenceValue !== hideValue ? (
        <div className="d-inline-block py-2 px-3 xmb-5 shadow rounded-3 position-relative" style={{ maxWidth: 250, backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
            <h4 className="mt-2 mb-3 d-flex gap-1">Getting started</h4>
            <ul className="list-unstyled mx-auto text-left">
                {[
                    { checked: isLoggedInOnDesktop, loading: loadingTokens, label: (
                            <>
                                Download {concepts.Photo51}
                                <br />
                                <a
                                    className="btn btn-sm btn-primary me-2 d-inline-block"
                                    href={downloadLinks.mac}
                                    onClick={() => trackEvent(CATEGORIES.FILE_DOWNLOAD, ACTIONS.DOWNLOAD_GETTING_STARTED, 'Mac')}
                                >
                                    <span className="d-flex align-items-center gap-1">
                                        <Apple /> Mac
                                    </span>
                                </a>
                                <a
                                    className="btn btn-sm btn-primary d-inline-block"
                                    href={downloadLinks.win}
                                    onClick={() => trackEvent(CATEGORIES.FILE_DOWNLOAD, ACTIONS.DOWNLOAD_GETTING_STARTED, 'Windows')}
                                >
                                    <span className="d-flex align-items-center gap-1">
                                        <Windows /> Windows
                                    </span>
                                </a>
                            </>
                        )},
                    { checked: hasGroups, label: <><a href={routes.groupsCreate}>Create</a> a {concepts.Group}</>},
                ].map(({ checked, label, loading }, idx) => (
                    <li className="d-flex gap-1 mb-3" key={idx}>
                            <span style={{ width: 30 }} className="text-left">
                                {loading ? <Loading size="sm" /> : <span>{checked ? filled : unfilled}</span>}
                            </span>
                        <span className={checked ? '': ''}>{label}</span>
                    </li>
                ))}
            </ul>
        </div>
    ) : null;
}

